import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemStats, ChartData, Alert, AdminAction } from '../../types/admin';

interface DashboardState {
  stats: SystemStats | null;
  charts: {
    userGrowth: ChartData[];
    productGrowth: ChartData[];
    transactionVolume: ChartData[];
  };
  alerts: Alert[];
  recentActions: AdminAction[];
  isLoading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  stats: null,
  charts: {
    userGrowth: [],
    productGrowth: [],
    transactionVolume: [],
  },
  alerts: [],
  recentActions: [],
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    fetchStatsStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchStatsSuccess: (state, action: PayloadAction<{
      stats: SystemStats;
      charts: {
        userGrowth: ChartData[];
        productGrowth: ChartData[];
        transactionVolume: ChartData[];
      };
      alerts: Alert[];
      recentActions: AdminAction[];
    }>) => {
      state.isLoading = false;
      state.stats = action.payload.stats;
      state.charts = action.payload.charts;
      state.alerts = action.payload.alerts;
      state.recentActions = action.payload.recentActions;
      state.error = null;
    },
    fetchStatsFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    markAlertAsRead: (state, action: PayloadAction<string>) => {
      const alert = state.alerts.find(a => a.id === action.payload);
      if (alert) {
        alert.isRead = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { 
  fetchStatsStart, 
  fetchStatsSuccess, 
  fetchStatsFailure, 
  markAlertAsRead,
  clearError 
} = dashboardSlice.actions;

export default dashboardSlice.reducer; 